import { render, staticRenderFns } from "./DesktopSubmenuItem.vue?vue&type=template&id=404925ae&scoped=true&"
import script from "./DesktopSubmenuItem.vue?vue&type=script&lang=js&"
export * from "./DesktopSubmenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404925ae",
  null
  
)

export default component.exports